<template>
  <div>
    <VInput
      v-bind="{...$attrs}"
      hide-details
    />
    <v-row align="center">
      <v-col cols="auto">
        <date-picker
          v-model="dValue.start"
          dense
          :max="dValue.end"
          hide-details
        />
      </v-col>
      <v-col cols="auto">
        <time-picker
          v-model="dValue.start"
          dense
          hide-details
        />
      </v-col>
      <v-col cols="auto">
        -
      </v-col>
      <v-col cols="auto">
        <time-picker
          v-model="dValue.end"
          :min="dValue.start"
          dense
          hide-details
        />
      </v-col>
      <v-col cols="auto">
        <date-picker
          v-model="dValue.end"
          :min="dValue.start"
          dense
          hide-details
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DatePicker from './DatePicker.vue'
import TimePicker from './TimePicker.vue'

const moment = require('@/plugins/moment').default(require('moment'))

export default {
  components: { DatePicker, TimePicker },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          start: moment().round(15, 'minutes').format('YYYY-MM-DD HH:mm:ss'),
          end: moment().round(15, 'minutes').add(15, 'minutes').format('YYYY-MM-DD HH:mm:ss')
        }
      }
    },
    allDay: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dValue: this.value
    }
  },
  computed: {
    startDate () {
      return this.value.start
    },
    endDate () {
      return this.value.end
    },
    isSameDay () {
      return moment(this.startDate).isSame(this.endDate, 'day')
    },
    formattedStartDate () {
      return moment(this.startDate).format('dddd, MMMM D')
    },
    formattedEndDate () {
      return moment(this.endDate).format('dddd, MMMM D')
    },
    formattedStartTime () {
      return moment(this.startDate).format('h:mm A')
    },
    formattedEndTime () {
      return moment(this.endDate).format('h:mm A')
    },
    display () {
      let init = '_sd_ ⋅ _st_ – _et_ ⋅ _ed_'

      if (this.isSameDay) {
        init = init.replace('⋅ _ed_', '')
      }
      if (this.allDay) {
        init = init.replace('_st_', '')
          .replace('_et_', '')
          .replace('⋅', '')
      }

      // if no et and ed, remove the dash
      if (this.isSameDay && this.allDay) {
        init = init.replace(' – ', '')
      }

      return init
        .replace('_sd_', this.formattedStartDate)
        .replace('_st_', this.formattedStartTime)
        .replace('_ed_', this.formattedEndDate)
        .replace('_et_', this.formattedEndTime)
    }
  },
  watch: {
    value: {
      handler (val) {
        this.dValue = val
      },
      immediate: true,
      deep: true
    },
    dValue: {
      handler (val) {
        this.$emit('input', val)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.v-select.fit {
  width: content;
  text-overflow: unset;
}
.v-select.fit  .v-select__selection--comma {
    text-overflow: unset;
}
</style>
